module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/placeholder-67453883a77230f94553f6d2c66ee02b.jpg";